<template>
    <div class="col-6">
        <div class="card">
            <div class="card-body">
                <div class="dropdown float-right">
                    <a href="#" class="dropdown-toggle card-drop" data-toggle="dropdown">
                        <i class="fas fa-ellipsis-v"/>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                        <li>
                            <a href="" @click.prevent="showCarrierModal" class="dropdown-item">
                                <i class="mr-1 fa fa-edit"/>
                                <span v-html="$t('CarrierInfoCard.edit')"/>
                            </a>
                        </li>
                    </ul>
                </div>
                <h4 class="header-title m-t-0">
                    <i class="fa fa-truck mr-1"/>
                    <span v-html="$t('CarrierInfoCard.carrierInfo')"/>
                </h4>
                <hr/>
                <p><b v-html="$t('CarrierInfoCard.name')"/>: <span v-html="carrier.name"/></p>
                <p><b v-html="$t('CarrierInfoCard.chargesBy')"/>: <CarrierChargesBy :carrier="carrier"/></p>
                <p v-if="carrier.chargesBy === 'weight'"><b v-html="$t('CarrierInfoCard.maxWeight')"/>: <span v-html="carrier.maxWeight"/> g</p>
                <p><b v-html="$t('CarrierInfoCard.enabledForProduction')"/>: <BooleanIcon :boolean="carrier.enabledForProduction"/></p>
                <p><b v-html="$t('CarrierInfoCard.enabledForDistribution')"/>: <BooleanIcon :boolean="carrier.enabledForDistribution"/></p>
                <p><b v-html="$t('CarrierInfoCard.enabledForApi')"/>: <BooleanIcon :boolean="carrier.enabledForApi"/></p>
                <p><b v-html="$t('CarrierInfoCard.needsGLN')"/>: <BooleanIcon :boolean="carrier.needsGLN"/></p>
                <p><b v-html="$t('CarrierInfoCard.private')"/>: <BooleanIcon :boolean="carrier.private"/></p>
            </div>
        </div>
        <CarrierFormModal @editCarrier="editCarrier" ref="CarrierFormModal"/>
    </div>
</template>

<script>
import CarrierFormModal from "./CarrierFormModal";
import BooleanIcon from "../../misc/BooleanIcon";
import CarrierChargesBy from "./CarrierChargesBy";
export default {
    name: "CarrierInfoCard",
    components: { CarrierChargesBy, BooleanIcon, CarrierFormModal },
    props: {
        carrier: {
            type: Object,
            required: true,
        },
    },
    methods: {
        showCarrierModal() {
            this.$refs.CarrierFormModal.show(this.carrier);
        },
        editCarrier(carrier) {
            this.$emit("editCarrier", carrier);
        },
    },
};
</script>

<style scoped>

</style>